module.exports = __webpack_public_path__ + "img/logo.cfd890e0.svg";